<div class="relative surface-card p-4 border-round-xl shadow-2 h-full cursor-pointer hover:shadow-4 transition-all transition-duration-200 flex flex-column justify-content-between"
    (click)="onClickCard()">

    <!-- Informations principales -->
    <div class="flex align-items-center justify-content-between mb-3">
        <!-- Société -->
        <div class="flex align-items-center gap-3">
            <div class="logo-container">
                @if (!!client!.avatar) {
                <p-avatar [image]="client!.avatar" size="xlarge" shape="circle" />
                } @else if (!!client!.logo) {
                <img class="w-full border-round" [src]="client!.logo" [alt]="client!.commercialName">
                } @else {
                <p-avatar [label]="client!.commercialName.toUpperCase()[0]" size="xlarge" shape="circle" />
                }
            </div>
            <div class="flex-1">
                <h4 class="m-0 text-900 mb-1">{{ client!.commercialName }}</h4>
                @if (client!.name && client!.name !== client!.commercialName) {
                <p class="m-0 text-600 text-sm">{{ client!.name }}</p>
                }
            </div>
        </div>

        <!-- Statut d'abonnement (pour les gestionnaires) -->
        @if (!!client?.subscription) {
        <div class="flex flex-column gap-2 justify-content-center align-items-end">
            <p-button [label]="getPackageLabel(client!.subscription.package.code)" [outlined]="true" [rounded]="true"
                size="small" [severity]="client!.subscription.package.severity"></p-button>
            @if (!!client!.subscription.dateTo) {
            <span class="text-xs text-500 font-italic">Jusqu'au {{ client!.subscription.dateTo.toDate() |
                date:'shortDate' }}</span>
            }
        </div>
        }
    </div>

    <!-- Compteurs -->
    <div class="flex flex-column gap-2 text-xs">
        <!-- Transactions bancaires -->
        <div class="flex align-items-center justify-content-between gap-2">
            <span class="text-600 font-medium">Transactions bancaires</span>
            <div class="flex align-items-center gap-2">
                <p-tag [value]="client!.unprocessedBankAccountLinesCount.toString()" severity="warn"
                    pTooltip="À traiter" tooltipPosition="top" [rounded]="true"></p-tag>
                <p-tag [value]="client!.unjustifiedBankAccountLinesCount.toString()" severity="primary"
                    pTooltip="À rapprocher" tooltipPosition="top" [rounded]="true"></p-tag>
                <p-tag [value]="client!.partiallyJustifiedBankAccountLinesCount.toString()" severity="success"
                    pTooltip="Partiellement rapprochées" tooltipPosition="top" [rounded]="true"></p-tag>
            </div>
        </div>

        <!-- Factures d'achat -->
        <div class="flex align-items-center justify-content-between gap-2">
            <span class="text-600 font-medium">Factures d'achat</span>
            <div class="flex align-items-center gap-2">
                <p-tag [value]="client!.draftPurchaseInvoicesCount.toString()" severity="warn" pTooltip="À traiter"
                    tooltipPosition="top" [rounded]="true"></p-tag>
                <p-tag [value]="client!.validatedPurchaseInvoicesCount.toString()" severity="primary"
                    pTooltip="Validées" tooltipPosition="top" [rounded]="true"></p-tag>
                <p-tag [value]="client!.partiallyPaidPurchaseInvoicesCount.toString()" severity="success"
                    pTooltip="Partiellement payées" tooltipPosition="top" [rounded]="true"></p-tag>
            </div>
        </div>

        <!-- Factures de vente -->
        <div class="flex align-items-center justify-content-between gap-2">
            <span class="text-600 font-medium">Factures de vente</span>
            <div class="flex align-items-center gap-2">
                <p-tag [value]="client!.draftSalesInvoicesCount.toString()" severity="warn"
                    pTooltip="À traiter / Brouillons" tooltipPosition="top" [rounded]="true"></p-tag>
                <p-tag [value]="client!.validatedSalesInvoicesCount.toString()" severity="primary"
                    pTooltip="Validées / Envoyées" tooltipPosition="top" [rounded]="true"></p-tag>
                <p-tag [value]="client!.partiallyPaidSalesInvoicesCount.toString()" severity="success"
                    pTooltip="Partiellement payées" tooltipPosition="top" [rounded]="true"></p-tag>
            </div>
        </div>
    </div>

    <!-- Boutons d'action pour les gestionnaires -->
    @if (accountantMode) {
    <p-divider></p-divider>
    <div class="flex align-items-center justify-content-between">
        <p-button label="Traiter le dossier" severity="primary" [rounded]="true" (click)="onClickSelect()"></p-button>
        @if (client?.subscription?.package?.code === Packages.Free) {
        <p-button label="Activer définitivement" severity="success" [rounded]="true" [raised]="true"
            [loading]="client?.busy" (click)="onClickActivate()"></p-button>
        }
    </div>
    }
</div>